<jw-modal id='newFormModal'>
  <div class="row">
    <div class="col">
      <h3>New Form</h3>
    </div>
  </div>

  <div class="row">
    <div class="col">
      Form name - only editable by current user - description
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="btn-group">
        <button class='btn btn-success' (click)='this.save()'>Save</button>
        <button class='btn btn-danger' (click)='this.cancel()'>Cancel</button>
      </div>
    </div>
  </div>
</jw-modal>
